import { RuleObject } from 'antd/lib/form';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

import { globalInputRegExp } from 'enums/regExp';

export const nepovoleneZnakyValidation = () => [
    () => ({
        validator(_rule: RuleObject, value: string) {
            if (!value || (value && globalInputRegExp.test(value))) return Promise.resolve();
            return Promise.reject(<TranslateText>VALIDACE_GLOBAL_INPUT</TranslateText>);
        }
    })
];

export default nepovoleneZnakyValidation;
